export default [
    {
        path: '/internal-tools/product/supplier-reply-review',
        name: 'internal-tools-product-supplier-reply-review',
        component: () => import('@/views/internal-tools/product/supplier-reply-review/SupplierReplyReview.vue'),
    },
]
